import * as React from 'react';
import {connect} from 'react-redux';

import type {SalesAutomationItemType} from '../../../../sales-automation/types';
import type {NutshellState} from '../../../../store';

import {
    getHeaderTitleForType,
    getHeaderSubtitleForType,
    getHelpComponent,
    getUncontrolledHelpComponent,
    getIsNewForType,
} from '../../constants';
import {toggleSectionExpansion} from '../../ui-actions';
import {getIsExpandedForType} from '../../ui-selectors';

import {SalesProcessInfoBar} from './sales-process-info-bar';

import styles from './collapsible-section.module.css';

function mapStateToProps(state: NutshellState, ownProps: OwnProps): StateProps {
    return {
        isExpanded: getIsExpandedForType(state, ownProps.type),
    };
}

// @ts-expect-error
const mapDispatchToProps = function (dispatch, ownProps: OwnProps): DispatchProps {
    return {
        onToggleSectionExpand: () => {
            dispatch(toggleSectionExpansion(ownProps.type));
        },
    };
};

type OwnProps = {
    type: SalesAutomationItemType;
    isCollapsible?: boolean;
    children?: React.ReactNode;
};

type StateProps = {
    isExpanded: boolean;
};

type DispatchProps = {
    onToggleSectionExpand: (type: SalesAutomationItemType) => any;
};

type Props = OwnProps & StateProps & DispatchProps;

/*
 * "Presentational" component responsible for rendering a bunch of columns
 * of cards.
 */
export class CollapsibleSectionComponent extends React.PureComponent<Props> {
    static defaultProps = {
        isCollapsible: true,
    };

    render() {
        const isExpanded = this.props.isExpanded || !this.props.isCollapsible;

        return (
            <div className={styles.container}>
                <SalesProcessInfoBar
                    isCollapsible={Boolean(this.props.isCollapsible)}
                    isExpanded={this.props.isExpanded}
                    onToggleExpand={this.handleToggleExpand}
                    titleText={getHeaderTitleForType(this.props.type)}
                    subtitleText={getHeaderSubtitleForType(this.props.type)}
                    helpComponent={getHelpComponent(this.props.type)}
                    uncontrolledHelpComponent={getUncontrolledHelpComponent(this.props.type)}
                    isNew={getIsNewForType(this.props.type)}
                />
                <div
                    className={
                        isExpanded
                            ? styles['stages-container']
                            : styles['stages-container--collapsed']
                    }
                >
                    {this.props.children}
                </div>
            </div>
        );
    }

    handleToggleExpand = () => {
        this.props.onToggleSectionExpand(this.props.type);
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const CollapsibleSection = connector(CollapsibleSectionComponent);
